<sp-base-grid-layout [disableElementsPanel]="true" [disableControlsPanel]="true">
    <web-header header></web-header>
    <web-preview preview></web-preview>
    <web-content content class="panel-options-boundary"></web-content>
    <web-block-drawer drawer></web-block-drawer>
    <web-page-drawer pageDrawer></web-page-drawer>
    <web-navigation-drawer navigationDrawer></web-navigation-drawer>
    @if (isAiChatEnabled) {
        <web-ai-chat-drawer aiChatDrawer></web-ai-chat-drawer>
    }
</sp-base-grid-layout>

<sp-loader [loaderId]="'main'"></sp-loader>
